import React, { useRef, useEffect } from "react";
import ReactDOM from "react-dom";

export default function Modal({ onClose, children, largura = 1100 }) {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = 0;
  }, []);

  return ReactDOM.createPortal(
    <div style={{ position: "fixed", inset: 0, zIndex: 9999 }}>
      <div onClick={onClose} style={{
        position: "absolute", inset: 0,
        background: "rgba(0,0,0,0.75)",
        backdropFilter: "blur(2px)",
      }} />
      <div ref={scrollRef} style={{
        position: "absolute", inset: 0,
        overflowY: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "80px 20px 40px",
      }}>
        <div onClick={e => e.stopPropagation()} style={{
          background: "var(--bg2)",
          border: "1px solid var(--border)",
          borderRadius: 18,
          boxShadow: "0 16px 60px rgba(0,0,0,0.6)",
          padding: 32,
          width: "100%",
          maxWidth: largura,
        }}>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}